"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UITileSection;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _TileContext = require("../context/TileContext");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: ", ";\n\n  ", "\n\n  .private-tile__section + & {\n    padding-top: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding-left: 0;\n  padding-right: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var flushMixin = (0, _styledComponents.css)(_templateObject());

var TileSection = _styledComponents.default.div.withConfig({
  displayName: "UITileSection__TileSection",
  componentId: "sc-8w0o1j-0"
})(_templateObject2(), function (_ref) {
  var compact = _ref.compact;
  return compact ? '20px' : '32px';
}, function (_ref2) {
  var flush = _ref2.flush;
  return flush && flushMixin;
});

function UITileSection(_ref3) {
  var className = _ref3.className,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["className"]);

  var _useContext = (0, _react.useContext)(_TileContext.TileContext),
      compact = _useContext.compact;

  return _react.default.createElement(TileSection, (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-tile__section', 'has--vertical-spacing', className),
    compact: compact
  }));
}

UITileSection.defaultProps = {
  flush: false
};
UITileSection.propTypes = {
  children: _propTypes.default.node,
  flush: _propTypes.default.bool
};
UITileSection.displayName = 'UITileSection';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/tile/UITileSection.js
// module id = 510
// module chunks = 5 6